module.exports = __webpack_public_path__ + "static/goforthshow-13d895d111cf70cd7ea9f461892e33ba.jpg";